import React, { useEffect, useState } from "react"
import { Container, Menu } from "@mui/material"
import { Link, useNavigate } from "react-router-dom";
import fetch from "../../../utils/fetch";
import icons from '../../../utils/icons.json';
import { addSubProduct } from "../../../store/subProducts";
import { useDispatch, useSelector } from "react-redux";




const Shopbycategorybutton = ({ conditions }) => {
    const navigate = useNavigate()

    const [conwidth, setconwidth] = useState(250);

    const [anchorEl, setAnchorEl] = useState('');
    const open = Boolean(anchorEl);
    const dispatch = useDispatch();

    const categories = useSelector((state) => state.categories.data);
    const subProducts = useSelector((state) => state.subProducts.data);


    const [categoriesGroups, setCategoriesGroups] = useState([]);
    const [categoriesToView, setCategoriesToView] = useState([]);
    const [categoriesPos, setCategoriesPos] = useState(0);



    useEffect(() => {
        loadSubProducts();
        window.scroll({ top: 0, behaviour: 'smooth' });
    }, []);



    useEffect(() => {
        if (categories) {
            if (categories.length > 11) {
                setCategoriesGroups(_.chunk(categories, 10));
            } else {
                setCategoriesGroups([categories]);
            }
        }
    }, [categories]);

    useEffect(() => {
        if (categoriesGroups.length > 0) {
            setCategoriesToView(categoriesGroups[categoriesPos]);
        }
    }, [categoriesGroups, categoriesPos]);


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setconwidth(250)
    };
    const handleClose = () => {
        setAnchorEl(null);
        setconwidth(250)
    };


    function loadSubProducts() {
        if (subProducts.length > 0) return;
        fetch
            .get('itemsandgroupscarousel')
            .then((res) => {
                dispatch(addSubProduct(res.list));
            })
    }




    return (
        <div>
            <div className="link" onMouseEnter={handleClick} onClick={handleClick}  >Shop By Category</div>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                sx={{ marginTop: 2}}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                    dense: true
                }}
            >
                <Container maxWidth="lg" disableGutters sx={{ width: conwidth}}>
                    <div onMouseLeave={handleClose} className="min-body sections">
                        <div className="categories">
                            <ul>
                                <p>Categories</p>
                                {categoriesToView.length > 0 &&
                                    categoriesToView.map((data, index) => (
                                        <Link onClick={handleClose} onMouseEnter={()=>setconwidth(490)} to={`/categories/${data.item_group}`} key={data.item_group + index}>
                                            <li key={index}>
                                                {_.startCase(data.group_name)}
                                                {data.subgroups.length > 0 && (
                                                    <>
                                                        <span dangerouslySetInnerHTML={{ __html: icons.angle_right }}></span>
                                                        <ul >
                                                            <p>{_.startCase(data.group_name)}</p>
                                                            {data.subgroups.map((sub_group, index) => (
                                                                <Link onMouseEnter={()=>setconwidth(700)} onClick={handleClose} to={`/categories/${data.item_group}/${sub_group.sub_group}`} key={data.item_group + sub_group.sub_group + index}>
                                                                    <li key={index}>
                                                                        {_.startCase(sub_group.sub_group_name)}
                                                                        {data.categories.filter((sub) => sub.sub_group == sub_group.sub_group).length > 0 && (
                                                                            <>
                                                                                <span dangerouslySetInnerHTML={{ __html: icons.angle_right }}></span>
                                                                                <ul>
                                                                                    <p>{_.startCase(sub_group.sub_group_name)}</p>
                                                                                    {data.categories
                                                                                        .filter((sub) => sub.sub_group == sub_group.sub_group)
                                                                                        .map((each, index) => (
                                                                                            <Link
                                                                                                onClick={handleClose}
                                                                                                to={`/categories/${data.item_group}/${sub_group.sub_group}/${each.categoryCode}`}
                                                                                                key={sub_group.sub_group + each.categoryCode + index}
                                                                                            >
                                                                                                <li key={index}>{_.startCase(each.categoryName)}</li>
                                                                                            </Link>
                                                                                        ))}
                                                                                </ul>
                                                                            </>
                                                                        )}
                                                                    </li>
                                                                </Link>
                                                            ))}
                                                        </ul>
                                                    </>
                                                )}
                                            </li>
                                        </Link>
                                    ))}
                            </ul>
                            {categoriesGroups.length > 1 && (
                                <section className="categories-footer">
                                    <button
                                        onClick={(e) => {
                                            setCategoriesPos((prev) => {
                                                return prev - 1;
                                            });
                                        }}
                                        disabled={categoriesPos <= 0}
                                    >
                                        <span className="icon" dangerouslySetInnerHTML={{ __html: icons.angle_left }}></span>
                                        <span className="txt">Previous</span>
                                    </button>
                                    <button
                                        onClick={(e) => {
                                            setCategoriesPos((prev) => {
                                                return prev + 1;
                                            });
                                        }}
                                        disabled={categoriesPos + 1 >= categoriesGroups.length}
                                    >
                                        <span className="txt">Next</span>
                                        <span className="icon" dangerouslySetInnerHTML={{ __html: icons.angle_right }}></span>
                                    </button>
                                </section>
                            )}
                        </div>
                    </div>

                </Container>
            </Menu>
        </div>
    )
}

export default Shopbycategorybutton